/* Shonenbox section behaviour. One file, initialised per component, re-run on theme editor section loads. */
(function () {
  if (window.__sbMain) return;
  window.__sbMain = true;

  function qa(root, s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }
  function once(el, key) { if (el.dataset[key]) return false; el.dataset[key] = '1'; return true; }

  /* ---------- Product buy box ---------- */
  function initProduct(root) {
    if (!once(root, 'sbInit')) return;
    var dataEl = root.querySelector('[data-sb-product-json]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var variants = data.variants;
    var q = function (s) { return root.querySelector(s); };
    var money = function (cents, trim) {
      var n = (cents / 100).toFixed(2);
      if (trim && n.slice(-3) === '.00') n = n.slice(0, -3);
      var f = data.moneyFormat || '';
      return /amount/.test(f) ? f.replace(/\{\{\s*amount[^}]*\}\}/, n) : '$' + n;
    };

    /* Gallery */
    var track = q('[data-sb-track]');
    var thumbs = qa(root, '[data-thumb]');
    var slides = qa(root, '[data-slide]');
    var current = 0;
    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
      var t = thumbs[i];
      if (t && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
    function goTo(i) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      setActive(i);
    }
    var prev = q('[data-sb-prev]'), next = q('[data-sb-next]');
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    thumbs.forEach(function (t, idx) { t.addEventListener('click', function () { goTo(idx); }); });
    var st;
    if (track) track.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () {
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (i !== current) setActive(i);
      }, 80);
    }, { passive: true });

    /* Variant state */
    var input = q('[data-sb-variant-input]');
    var nameEl = q('[data-sb-variant-name]');
    var priceNow = q('[data-sb-price-now]');
    var priceWas = q('[data-sb-price-was]');
    var priceSave = q('[data-sb-price-save]');
    var atc = q('[data-sb-atc]');
    var atcText = q('[data-sb-atc-text]');
    var atcPrice = q('[data-sb-atc-price]');
    var stock = q('[data-sb-stock]');
    var stockText = q('[data-sb-stock-text]');
    var vImg = q('[data-sb-variant-image]');
    var vThumb = q('[data-sb-variant-thumb]');
    if (!input) return;

    function find(id) { for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i]; return null; }
    function findByTitle(t) { t = (t || '').toLowerCase(); for (var i = 0; i < variants.length; i++) if (variants[i].title.toLowerCase() === t) return variants[i]; return null; }

    function apply(v, opts) {
      opts = opts || {};
      if (!v) return;
      input.value = v.id;
      if (nameEl) nameEl.textContent = v.title;
      qa(root, '[data-sb-swatch]').forEach(function (s) {
        var on = String(s.dataset.variantId) === String(v.id);
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var compare = v.compare > v.price ? v.compare : (data.compareFallback > v.price ? data.compareFallback : 0);
      if (priceNow) priceNow.textContent = money(v.price);
      if (priceWas && priceSave) {
        if (compare) {
          priceWas.textContent = money(compare); priceWas.hidden = false;
          priceSave.textContent = 'Save ' + money(compare - v.price, true); priceSave.hidden = false;
        } else { priceWas.hidden = true; priceSave.hidden = true; }
      }
      if (atc) {
        if (v.available) { atc.disabled = false; if (atcText) atcText.textContent = data.ctaText; }
        else { atc.disabled = true; if (atcText) atcText.textContent = 'Sold out'; }
      }
      if (atcPrice) atcPrice.textContent = money(v.price);
      if (v.image && vImg) { vImg.src = v.image; if (vThumb) vThumb.src = v.image; }
      var show = false, txt = '';
      if (v.tracked && v.qty > 0 && v.qty <= data.lowStock.threshold) { show = true; txt = 'Only ' + v.qty + ' left in this run'; }
      else if (data.lowStock.series && v.title.toLowerCase() === String(data.lowStock.series).toLowerCase() && data.lowStock.text) { show = true; txt = data.lowStock.text; }
      if (stock) { stock.classList.toggle('is-visible', show); stockText.textContent = txt; }
      if (!opts.silent && window.history && window.history.replaceState) {
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); } catch (e) {}
      }
      input.dispatchEvent(new Event('change', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('sb:variant', { detail: { id: v.id, title: v.title, price: v.price, priceText: money(v.price), available: v.available } }));
      if (!opts.silent) goTo(0);
    }

    qa(root, '[data-sb-swatch]').forEach(function (s) {
      s.addEventListener('click', function () { apply(find(s.dataset.variantId)); });
    });
    document.addEventListener('sb:select-series', function (e) {
      var v = findByTitle(e.detail && e.detail.title);
      if (v) { apply(v); var box = document.getElementById('sb-buybox'); if (box) box.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
    document.addEventListener('sb:submit', function () { if (atc && !atc.disabled) atc.click(); });

    apply(find(input.value), { silent: true });
  }

  /* ---------- Sticky add to cart ---------- */
  function initSticky(bar) {
    if (!once(bar, 'sbInit')) return;
    var series = bar.querySelector('[data-sb-sticky-series]');
    var price = bar.querySelector('[data-sb-sticky-price]');
    var btnPrice = bar.querySelector('[data-sb-sticky-btn-price]');
    var btn = bar.querySelector('[data-sb-sticky-btn]');
    var was = bar.querySelector('[data-sb-sticky-was]');
    if (bar.dataset.compare) { was.textContent = bar.dataset.compare; was.hidden = false; }
    document.addEventListener('sb:variant', function (e) {
      var d = e.detail || {};
      if (d.title) series.textContent = d.title;
      price.textContent = d.priceText || '';
      btnPrice.textContent = d.priceText || '';
      btn.disabled = d.available === false;
    });
    btn.addEventListener('click', function () { document.dispatchEvent(new CustomEvent('sb:submit')); });
    var prod = document.querySelector('[data-sb-product]');
    if (prod) {
      var n = prod.querySelector('[data-sb-variant-name]'), p = prod.querySelector('[data-sb-price-now]'), a = prod.querySelector('[data-sb-atc]');
      if (n) series.textContent = n.textContent;
      if (p) { price.textContent = p.textContent.trim(); btnPrice.textContent = p.textContent.trim(); }
      if (a) btn.disabled = a.disabled;
    }
    var anchor = document.getElementById('sb-atc-anchor');
    if (!anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('sb-sticky-open', show);
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ---------- Announcement rotator ---------- */
  function initAnnouncement(el) {
    if (!once(el, 'sbInit')) return;
    var items = el.querySelectorAll('.sb-ann__item');
    if (items.length < 2) return;
    var i = 0, ms = (parseInt(el.dataset.interval, 10) || 4) * 1000;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, ms);
  }

  /* ---------- Series cards ---------- */
  function initSeries(root) {
    if (!once(root, 'sbInit')) return;
    qa(root, '[data-sb-choose]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var title = btn.getAttribute('data-sb-choose');
        if (document.querySelector('[data-sb-product]')) {
          document.dispatchEvent(new CustomEvent('sb:select-series', { detail: { title: title } }));
        } else {
          window.location.href = (root.dataset.fallback || '/') + '#sb-buybox';
        }
      });
    });
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq(root) {
    if (!once(root, 'sbInit')) return;
    var items = qa(root, '.sb-faq__item');
    var single = root.dataset.single === 'true';
    function setOpen(item, open) {
      var a = item.querySelector('.sb-faq__a'), q = item.querySelector('.sb-faq__q');
      item.classList.toggle('is-open', open);
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
      a.style.maxHeight = open ? a.scrollHeight + 'px' : '0px';
    }
    items.forEach(function (item) {
      if (item.classList.contains('is-open')) setOpen(item, true);
      item.querySelector('.sb-faq__q').addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        if (single) items.forEach(function (o) { if (o !== item) setOpen(o, false); });
        setOpen(item, open);
      });
    });
    window.addEventListener('resize', function () { items.forEach(function (i) { if (i.classList.contains('is-open')) setOpen(i, true); }); });
  }

  /* ---------- Urgency countdown ---------- */
  function initUrgency(el) {
    if (!once(el, 'sbInit')) return;
    var parts = (el.dataset.cutoff || '').split('-').map(Number);
    if (parts.length < 3 || isNaN(parts[0])) return;
    var cutoff = new Date(parts[0], parts[1] - 1, parts[2], 23, 59, 59);
    var label = el.querySelector('[data-sb-cutoff-label]');
    if (label) label.textContent = cutoff.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
    var u = {}; ['d', 'h', 'm', 's'].forEach(function (k) { u[k] = el.querySelector('[data-u="' + k + '"]'); });
    var before = el.querySelector('[data-sb-before]'), after = el.querySelector('[data-sb-after]');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var diff = cutoff - new Date();
      if (diff <= 0) { el.dataset.state = 'after'; before.hidden = true; after.hidden = false; return; }
      u.d.textContent = pad(Math.floor(diff / 864e5));
      u.h.textContent = pad(Math.floor(diff % 864e5 / 36e5));
      u.m.textContent = pad(Math.floor(diff % 36e5 / 6e4));
      u.s.textContent = pad(Math.floor(diff % 6e4 / 1e3));
      setTimeout(tick, 1000);
    }
    tick();
  }

  function initAll(scope) {
    scope = scope || document;
    qa(scope, '[data-sb-product]').forEach(initProduct);
    qa(scope, '[data-sb-sticky]').forEach(initSticky);
    qa(scope, '.sb-ann').forEach(initAnnouncement);
    qa(scope, '[data-sb-series]').forEach(initSeries);
    qa(scope, '[data-sb-faq]').forEach(initFaq);
    qa(scope, '[data-sb-urgency]').forEach(initUrgency);
    if (scope.matches) {
      if (scope.matches('[data-sb-product]')) initProduct(scope);
      if (scope.matches('[data-sb-sticky]')) initSticky(scope);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
